import validate from "/var/www/homedelimercado.com/node_modules/nuxt/dist/pages/runtime/validate.js";
import admin_45global from "/var/www/homedelimercado.com/middleware/admin.global.ts";
import inactivity_45global from "/var/www/homedelimercado.com/middleware/inactivity.global.ts";
import redirect_45global from "/var/www/homedelimercado.com/middleware/redirect.global.ts";
import session_45global from "/var/www/homedelimercado.com/middleware/session.global.ts";
import manifest_45route_45rule from "/var/www/homedelimercado.com/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  admin_45global,
  inactivity_45global,
  redirect_45global,
  session_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-create-product": () => import("/var/www/homedelimercado.com/middleware/checkCreateProduct.ts"),
  "check-customization-settings": () => import("/var/www/homedelimercado.com/middleware/checkCustomizationSettings.ts"),
  "check-edit-coin": () => import("/var/www/homedelimercado.com/middleware/checkEditCoin.ts"),
  "check-edit-product": () => import("/var/www/homedelimercado.com/middleware/checkEditProduct.ts"),
  "check-notifications-settings": () => import("/var/www/homedelimercado.com/middleware/checkNotificationsSettings.ts"),
  "check-order-owner": () => import("/var/www/homedelimercado.com/middleware/checkOrderOwner.ts"),
  "check-shopping-card-info": () => import("/var/www/homedelimercado.com/middleware/checkShoppingCardInfo.ts"),
  registered: () => import("/var/www/homedelimercado.com/middleware/registered.ts"),
  "sanctum:auth": () => import("/var/www/homedelimercado.com/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.auth.js"),
  "sanctum:guest": () => import("/var/www/homedelimercado.com/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.guest.js")
}